// ProvidingExpertSpecialtyCareSection.js
import React from "react";
import { Phone } from "lucide-react";
import providingExpertSpecialtyCareImage from "../assets/providing-expert-specialty-care-image.jpg";

const ProvidingExpertSpecialtyCareSection = () => {
  return (
    <section className="py-16 px-6 md:px-12 lg:px-24 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-6 leading-tight">
              Providing Expert Specialty Care for Complex Health Needs
            </h2>

            <div className="space-y-4 text-gray-700 font-light leading-relaxed mb-8">
              <p>
                At Allawah Lodge, we understand that specialty care requires
                more than routine support — it demands expertise, empathy, and
                consistency. Whether recovering after a hospital stay, managing
                a chronic condition, or living with a disability, our caregivers
                deliver tailored in-home care that promotes safety, comfort, and
                independence. Every care plan is designed around the unique
                needs of each client, ensuring personalised attention and peace
                of mind for families.
              </p>

              <p>
                From medication reminders and meal preparation to mobility
                assistance and household upkeep, we focus on helping clients
                maintain their routines with dignity and confidence. Our
                specialty care programmes are flexible and personalised, giving
                families the reassurance that their loved ones are receiving
                exceptional care in the place they feel most comfortable — home.
              </p>
            </div>

            <a
              href="tel:+61269272706"
              className="inline-flex items-center gap-2 bg-[#E85D2C] hover:bg-[#d54d1f] text-white font-medium px-6 py-3 rounded-full transition-colors"
            >
              <Phone size={20} />
              CALL: (02) 6927 2706
            </a>
          </div>

          {/* Right Image */}
          <div>
            <img
              src={providingExpertSpecialtyCareImage}
              alt="Caregiver assisting elderly man with walker"
              className="w-full h-auto rounded-2xl shadow-lg object-cover"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProvidingExpertSpecialtyCareSection;
